import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {Button, Col, Form, Input, message, Row} from "antd";
import http from "../framework/http";

function ContactUs() {
    const params = useParams();
    const [form] = Form.useForm();
    const [isGetVerificationCodeButtonDisabled, setIsGetVerificationCodeButtonDisabled] = useState(false);
    const [isGetVerificationCodeButtonLoading, setIsGetVerificationCodeButtonLoading] = useState(false);
    const [countdown, setCountdown] = useState(0);
    const [isSendButtonLoading,setIsSendButtonLoading] = useState(false);

    useEffect(() => {
        form.setFieldValue("subject", params.msg)
    }, [params])

    const getVerificationCode = async () => {
        try {
            setIsGetVerificationCodeButtonLoading(true);
            await form.validateFields(['email']);// validate email, if failed, there will be error threw

            const email = form.getFieldValue('email');
            const res = await http.get("/getVerificationCode", {params: {email: email}});

            if (res.data.code === 200) {
                message.success('Verification code sent successfully!');
                startCountdown();
            } else {
                message.error(res.data.msg || 'Failed to send verification code.');
            }
            setIsGetVerificationCodeButtonLoading(false);
        } catch (error) {
            form.scrollToField('email');
            message.warning("Invalid email")
            setIsGetVerificationCodeButtonLoading(false);
        }
    }

    const startCountdown = () => {
        setIsGetVerificationCodeButtonDisabled(true);
        setCountdown(60);
        const timer = setInterval(() => {
            setCountdown(prevCount => {
                if (prevCount === 1) {
                    clearInterval(timer);
                    setIsGetVerificationCodeButtonDisabled(false);
                    return 0;
                }
                return prevCount - 1;
            });
        }, 1000);
    };

    const submitForm = async (formData) => {
        setIsSendButtonLoading(true);
        const res = await http.post("/query", formData);
        if (res.data?.code === 200) {
            message.success("Message sent!");
            setIsSendButtonLoading(false);
            // form.resetFields();
        } else if (res.data?.code !== 401) {
            message.error(res.data?.msg || "Error, please try again later");
            setIsSendButtonLoading(false);
        }
    }

    return (
        <div className="about-us-container">
            {/* Hero Section */}
            <section className="about-hero">
                <div className="about-hero-content">
                    <h1>Contact Us</h1>
                    <p className="hero-lead">Get in Touch - We're Here to Help</p>
                </div>
            </section>

            {/* Main Content */}
            <section className="about-content">
                <div className="container">
                    <Row gutter={[48, 48]}>
                        <Col xs={24} lg={16}>
                            <div className="about-text">
                                <h2>Send Us a Message</h2>
                                <p>
                                    Have a question about our repair services? Need a quote? Or just want to get in touch?
                                    Fill out the form below and our team will get back to you as soon as possible.
                                </p>

                                <Form
                                    form={form}
                                    onFinish={submitForm}
                                    layout="vertical"
                                    size="large"
                                    style={{marginTop: '32px'}}
                                >
                                    <Form.Item
                                        label="Your Name"
                                        name="name"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter your name',
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Enter your full name" />
                                    </Form.Item>

                                    <Form.Item
                                        name="email"
                                        label="Your Email"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter your email',
                                            },
                                            {
                                                type: 'email',
                                                message: 'Please enter a valid email address',
                                            }
                                        ]}
                                    >
                                        <Input placeholder="your.email@example.com" maxLength={128} />
                                    </Form.Item>

                                    <Form.Item
                                        label="Subject"
                                        name="subject"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter a subject',
                                            },
                                        ]}
                                    >
                                        <Input placeholder="What is this regarding?" />
                                    </Form.Item>

                                    <Form.Item
                                        label="Your Message"
                                        name="message"
                                    >
                                        <Input.TextArea
                                            rows={6}
                                            placeholder="Tell us how we can help you..."
                                        />
                                    </Form.Item>

                                    <Form.Item label="Email Verification Code" required>
                                        <Row gutter={12}>
                                            <Col span={14}>
                                                <Form.Item
                                                    name="verificationCode"
                                                    noStyle
                                                    rules={[{
                                                        required: true,
                                                        message: 'Please enter verification code',
                                                    }, {
                                                        validator: (_, value) => {
                                                            const codeRegex = /^\d{6}$/;
                                                            if (!value) {
                                                                return Promise.reject();
                                                            }
                                                            if (!codeRegex.test(value)) {
                                                                return Promise.reject(new Error('Code must be 6 digits'));
                                                            }
                                                            return Promise.resolve();
                                                        },
                                                    }]}
                                                >
                                                    <Input
                                                        placeholder="Enter 6-digit code"
                                                        onKeyPress={(e) => {
                                                            if (!/^\d$/.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={10}>
                                                <Button
                                                    style={{width: "100%"}}
                                                    disabled={isGetVerificationCodeButtonDisabled}
                                                    loading={isGetVerificationCodeButtonLoading}
                                                    onClick={getVerificationCode}
                                                >
                                                    {isGetVerificationCodeButtonDisabled ? `${countdown}s` : 'Send Code'}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form.Item>

                                    <Form.Item>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            style={{width: '100%', height: '48px', fontSize: '16px', fontWeight: '600'}}
                                            loading={isSendButtonLoading}
                                        >
                                            Send Message
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        </Col>
                        <Col xs={24} lg={8}>
                            <div className="about-text">
                                <h2>Contact Information</h2>
                                <p>
                                    <strong>Email:</strong><br />
                                    etechdundrum@gmail.com
                                </p>
                                <p>
                                    <strong>Phone:</strong><br />
                                    +353 15341721
                                </p>
                                <p>
                                    <strong>Address:</strong><br />
                                    1 Ballinteer Road Dundrum<br />
                                    Dublin 16<br />
                                    D15F5T7
                                </p>
                                <p>
                                    <strong>Business Hours:</strong><br />
                                    Monday - Saturday: 10:00AM - 6:00PM<br />
                                    Sunday: Closed<br />
                                    Bank Holiday: Closed
                                </p>
                                <p className="highlight-text">
                                    We typically respond to all inquiries within 24 hours during business days.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </div>
    );
}

export default ContactUs;
